<template>
  <v-app id="app">
    <!-- SIDEBAR -->
    <v-navigation-drawer
      v-if="configuracion"
      :style="`background-color: ${configuracion.color_sistema}`"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      absolute
      app
      temporary
    >
      <v-flex>
        <img :src="logoInstitucion" width="285px" />
      </v-flex>
      <v-divider light inset></v-divider>

      <v-list dense>
        <template v-for="item in items">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>

          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title
                    :style="`color: ${configuracion.color_fuente}`"
                  >
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile v-for="(child, i) in item.children" :key="i" @click="">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title style="height: auto">
                  <!-- <div :to="child.to"><p>{{ child.text }}</p></div> -->
                  <b-button
                    :variant="`color: ${configuracion.color_fuente}`"
                    block
                    class="button-style"
                    :to="child.to"
                    >{{ child.text }}</b-button
                  >

                  <!-- <v-btn style="text-decoration:none;" absolute flat small :to="child.to">{{ child.text }}</v-btn> -->
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <b-button
                  :variant="`color: ${configuracion.color_fuente}`"
                  block
                  class="button-style2"
                  :to="item.to"
                  >{{ item.text }}</b-button
                >
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-flex>
        <v-divider inset></v-divider>
        <a href="http://nlcti.i2t2.gob.mx" style="text-decoration: none">
          <v-btn title="ACCESO" block flat :color="configuracion.color_fuente">
            <v-icon></v-icon>PLATAFORMA NLCTI</v-btn
          >
        </a>
      </v-flex>
    </v-navigation-drawer>
    <!-- NAVBAR -->
    <template>
      <v-toolbar :color="configuracion.color_sistema" v-if="configuracion">
        <div class="sci_logoImg">
          <router-link to="/">
            <img :src="logoInstitucion" />
          </router-link>
        </div>
        <v-spacer v-show="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"></v-spacer>
        <v-toolbar-side-icon
          v-show="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>

        <v-spacer></v-spacer>

        <template v-for="itemNav in items">
          <div
            v-show="
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.xl
            "
            class="text-xs-center"
            :key="itemNav.text"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  flat
                  :color="configuracion.color_fuente"
                  v-on="on"
                  @click="$router.push(itemNav.to)"
                >
                  {{ itemNav.text }}
                  <v-icon small v-if="itemNav.children"> expand_more</v-icon>
                </v-btn>
              </template>
              <v-list v-if="itemNav.children">
                <v-list-tile
                  v-for="(itemChildren, index) in itemNav.children"
                  :key="index"
                  @click="$router.push(itemChildren.to)"
                >
                  <v-list-tile-title>{{ itemChildren.text }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </template>
        <v-hover>
          <v-btn
            v-show="
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.xl
            "
            href="http://nlcti.i2t2.gob.mx"
            target="_blank"
            small
            depressed
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 0} ${
              configuracion.color_sistema
            }--text`"
            round
            :color="configuracion.color_fuente"
            :style="{color: configuracion.color_sistema}"
            >PLATAFORMA NLCTI
            <v-icon :color="configuracion.color_sistema"
              >navigate_next</v-icon
            ></v-btn
          >
        </v-hover>
      </v-toolbar>
    </template>
    <v-content>
    <router-view v-if="loaded" :urlApi.sync="urlApi" :configuracion.sync="configuracion"></router-view>
    </v-content>
    <!-- FOOTER -->
    <v-footer height="auto" :color="configuracion.color_sistema" class="text-center">
      <v-layout class="pt-4" row wrap align-center justify-space-between>
        <v-flex xs12 sm12 md12 lg12>
          <div :style="`color: ${configuracion.color_fuente}`">
          {{getYear()}}, <a href="https://i2t2.gob.mx/"> {{configuracion.nombre_institucion}}</a>
          </div>
          <v-btn
            flat
            style="text-transform: none; text-decoration: none"
            :color="configuracion.color_fuente"
            :href="configuracion.acuerdo_privacidad"
            target="_blank"
            class="NoShadow"
            elevation="0"
            >Aviso de Privacidad</v-btn>  
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>


<script>
import axios from "axios";
export default {
  data: () => ({
    logos: [],
    configuracion: {},
    dialog: false,
    drawer: null,
    loaded: false,
    urlApi: process.env.VUE_APP_API_URL
  }),
  props: {
    source: String,
  },
  methods: {
    getRegister() {
      var url = this.urlApi;
      window.open(url);
    },
    getYear() {
      return new Date().getFullYear()
    },
  },
 
  async created() {
    await axios.get(process.env.VUE_APP_API_URL + `/api/get-configuracion`).then((response) => {
        this.configuracion = response.data[0];
        this.loaded = true;
      })
      .catch((error) => errorHandling(error));
    var urlLogos = process.env.VUE_APP_API_URL + "/api/get-logos";

    await axios.get(urlLogos).then((response) => {
      this.logos = response.data;
    })
    .catch((error) => errorHandling(error));
  },
  computed: {
    logoPrincipal() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_principal") {
          url = logo.url;
        }
      });
      return url;
    },
    logoSistema() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_sistema") {
          url = logo.url;
        }
      });
      return url;
    },
    logoInstitucion() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_institucion") {
          url = logo.url;
        }
      });
      return url;
    },
    logoGobierno() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_gobierno") {
          url = logo.url;
        }
      });
      return url;
    },
    logoCorreo() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_correo") {
          url = logo.url;
        }
      });
      return url;
    },
    logoCorreoFooter() {
      let url = "";
      this.logos.map((logo) => {
        if (logo.slug == "logo_correo_footer") {
          url = logo.url;
        }
      });
      return url;
    },
    imageHeight () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '70px'
          case 'sm': return '70px'
          case 'md': return '80px'
          case 'lg': return '80px'
          case 'xl': return '80px'
      }
    },
    items () {
      if(this.configuracion != null){
        let items = [
        { icon: "home", text: "INICIO", to: "/" },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "SEICYT",
          model: false,
          children: [
            { text: "¿Qué es?", to: "/quienes_somos" },
            { text: "Marco Normativo", to: "/marco_normativo" },
            { text: "Sistema Estatal de Investigadores", to: "/sei" },
            { text: "Enlaces de interés", to: "/enlaces-interes" },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "PADRÓN",
          model: false,
          children: [
            { text: "Investigadores", to: "/investigadores" },
            {
              text: "Empresa | Asociación | ONG | Clúster",
              to: "/organizaciones",
            },
            { text: "Instituciones académicas", to: "/academicas" },
            /* { text: "Instituciones gubernamentales", to: "/gubernamental" }, */
          ],
        },
        /* {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "CAPACIDADES CTI",
          model: false,
          children: [
            { text: "Infraestructura", to: "/infraestructura" },
            { text: "Equipo Especializado", to: "/equipo-especializado" },
            { text: "Grupos de Investigación", to: "/grupos-investigacion" },
            { text: "Oferta de Servicios", to: "/servicios" },
            { text: "Vinculación", to: "/vinculacion" },
            { text: "Certificación", to: "/certificaciones" },
            // { text: "Áreas de Investigación", to: "/areas-investigacion" },
          ],
        }, */
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "CONSULTAS",
          model: false,
          children: [
            {
              text: "Proyectos de Investigación",
              to: "/proyectos-de-investigacion",
            },
            { text: "Productividad", to: "/productividad" },
            /* { text: "Capital humano", to: "/capital_humano" }, */
            { text: "Convocatorias", to: "/convocatorias" },
          ],
        },
        ]
        return items;
      }
    }
  },
};
</script>


<style>
a {
  text-decoration: none !important;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Lato", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.sci_navbar {
  padding: 0 !important;
  height: 77px;
  background: #00002e;
  text-transform: initial;
  font-size: 1em;
  box-shadow: -6px -5px 15px rgba(0, 0, 0, 0.5);
  display: grid !important;
  justify-items: end !important;
  justify-content: stretch !important;
  grid-template-areas: "sci_logo sci_links";
  z-index: 2;
}
.navbar-dark .navbar-toggler {
  background: rgba(159, 159, 159, 0.9);
}
.navbar-dark .navbar-nav .nav-link {
  color: #fff !important;
  height: 100%;
}
.sci_logo {
  display: grid;
  width: 100%;
  justify-self: center;
  grid-area: sci_logo;
  margin-right: 0;
}
.sci_logoImg {
  display: grid;
  align-content: center;
}
.sci_logoImg img {
  justify-self: center;
  width: 15rem;
}
.sci_links {
  display: grid !important;
  grid-template-columns: 2fr 2fr 2fr 2fr 3fr 2fr 5fr;
  width: 100%;
  grid-area: sci_links;
  grid-gap: 2%;
  height: 77px;
  justify-items: center;
}
.sci_links a {
  display: grid;
  color: rgba(0, 0, 36, 1);
  text-decoration: none;
  letter-spacing: 1px;
  align-items: center;
  padding: 0 30px;
  align-content: center;
  display: flex;
  line-height: 20pt;
}
.dropdown_nav {
  align-content: center;
  display: flex;
}
.sci-home-linkSystem {
  display: grid;
  font-weight: bold;
  color: #fff !important;
  text-decoration: none;
  letter-spacing: 1px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 30px;
  background-color: rgba(0, 132, 255, 0.9);
  border-radius: 15px 15px 15px 15px;
  /* border: none;
    transition: all 0.3s ease 0s; */
}
/* .sci-home-linkSystem:hover {
color:  rgba(0,132,255,.9) !important;
font-weight: 700 !important;
letter-spacing: 3px;
font-weight: bold;
background: none;
-webkit-box-shadow: 0px 5px 40px -10px rgba(0,0,0,0.57);
-moz-box-shadow: 0px 5px 40px -10px rgba(0,0,0,0.57);
transition: all 0.3s ease 0s;
} */

.sci_links a.router-link-exact-active {
  color: rgba(0, 132, 255, 0.9) !important;
  border-bottom: 2px solid rgba(0, 132, 255, 0.9);
  text-decoration: none !important;
}
.sci_links a:hover {
  text-decoration: none !important;
}

.sci-home-textContent {
  width: 100%;
  display: grid;
  height: 200px;
  background: rgba(0, 0, 36, 1);
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 20vh 1fr;
  position: absolute;
  bottom: -3%;
  margin-top: 1.65vh;
}
.logo_cocyted {
  display: grid;
  height: 45px;
  margin: 0 auto;
  align-self: end;
}
.logo_gobierno {
  display: grid;
  height: 45px;
  margin: 0 auto;
  align-self: end;
}
.logo_cocyted2 {
  display: grid;
  height: 60px;
  margin: 0 auto;
  align-self: end;
}
.sci-home-textContent a {
  display: grid;
}
.sci-home-powered {
  padding: 0;
  margin: 0;
  color: #fff;
  /* grid-column: 1 / 4;
    grid-row: 3 / 4; */
  align-self: flex-end;
}
.sci-home-powered2 {
  padding: 0;
  margin: 0;
  color: #fff;
  font-size: 11px;
  /* grid-column: 1 / 4;
    grid-row: 3 / 4; */
  align-self: flex-end;
}
.logo_conacyt {
  display: grid;
  height: 50px;
  margin: 0 auto;
  align-self: end;
}
.sci-home-text {
  display: grid;
  color: #fff;
  font-size: 1em;
  align-items: end;
  margin: 0 !important;
  letter-spacing: 2px;
  word-spacing: 1px;
  justify-content: center;
}
.sci-contact-text {
  display: grid;
  color: #fff;
  font-size: 12px;
  align-items: end;
  margin: 0 !important;
  letter-spacing: 2px;
  word-spacing: 1px;
  justify-content: center;
}
.letter_contact_title {
  font-size: 20px;
  letter-spacing: 6px;
}
.letter_contact {
  font-size: 0.9em;
  display: contents;
  letter-spacing: 1.6px;
}
.letter_contact2 {
  font-size: 0.9em;
  letter-spacing: 1.6px;
}
@media only screen and (min-width: 991px) {
  .sci_navbar {
    font-size: 0.8em;
  }
  .btn_nav {
    display: none !important;
  }
}

@media only screen and (max-width: 991px) and (min-width: 300px) {
  .sci_navbar {
    padding: 0.5rem 1rem !important;
    height: auto !important;
  }
  .sci_links {
    height: 185px;
    grid-template-columns: 1fr !important;
    justify-items: center;
  }
  .sci_links a.router-link-exact-active {
    border-bottom: 2px solid rgba(0, 132, 255, 0.9);
  }
}

/*btn_background*/
.effect04 {
  --uismLinkDisplay: var(--smLinkDisplay, inline-flex);
  display: var(--uismLinkDisplay);
  color: #000;
  position: relative;
  transition-duration: 0.4s;
  overflow: hidden;
}

.effect04::before,
.effect04 span {
  margin: 0 auto;
  transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
  transition-duration: 0.4s;
}

.effect04:hover {
  background-color: #fff;
}

.effect04:hover span {
  -webkit-transform: translateY(-400%) scale(-0.1, 20);
  transform: translateY(-400%) scale(-0.1, 20);
}

.effect04::before {
  content: attr(data-sm-link-text);
  color: rgba(0, 132, 255, 0.9);
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  -webkit-transform: translateY(500%) scale(-0.1, 20);
  transform: translateY(500%) scale(-0.1, 20);
}

.effect04:hover::before {
  letter-spacing: 0.05em;
  -webkit-transform: translateY(0) scale(1, 1);
  transform: translateY(0) scale(1, 1);
}
.NoShadow {
  box-shadow: none;
  border: none;
}
.text-center{
  text-align: center;
}
.button-style {
  text-align: left !important;
  background: transparent;
  outline-style: none;
  border-color: transparent !important;               
}
.button-style2{
  text-align: left !important;
  background: transparent;
  outline-style: none;
  border-color: transparent !important;
  margin-left: -12px;
}
</style>